export default __webpack_public_path__ + "static/relief-bg-dark-0bf0392aa4194a23a0d78f954c263856.png";